import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'

export const ArrowLong: FC<IconProps> = ({ width = 20, height = 36, ...rest }) => (
  <Icon type="ArrowLong" width={width} height={height} alt="Arrow" {...rest} />
)

export default ArrowLong
